<template>
  <div class='SelectFont'>
    <div class="label">
      <div class="text-label">Fonte Padrão</div>
      <div class="arrow">
        <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
      </div>
    </div>
    <div class="cont-select" :class="{ contselect: sublink }">
      <div class="cont-s">
        <input-select
        :value="Prefes.global.font"
        :data="Fonts"
        @update:modelValue="newValue => UpdateFontDefault(newValue)"
        :label="{ display: 'none' }"
        :input="{ width: '100%', padding: '2%', fontSize: '16px', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
      </div>
      <div class="cont-r">
        <input-reg
        text="Tamanho da fonte(px)"
        :value="Prefes.global.fontHeight"
        @update:model-value="newValue => newValue !== '' ? UpdateFontHeightDefault(newValue): '18'"
        :cont="{ textAlign: 'left' }"
        :label="{ paddingTop: '3px', fontSize: '16px' }"
        :input="{ fontSize: '18px', padding: '1.5%', width: '96%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputSelect from '../Produtos/Register/InputSelect'
import ArrowIcon from '../Icons/ArrowIcon'
import InputReg from '@/components/EnbPainel/Produtos/Register/InputReg'
export default {
  name: 'SelectFont',
  components: { InputSelect, ArrowIcon, InputReg },
  data () {
    return {
      sublink: false
    }
  },
  computed: {
    ...mapGetters(['Fonts', 'Prefes'])
  },
  methods: {
    ...mapActions(['UpdateFontDefault', 'UpdateFontHeightDefault'])
  }
}
</script>

<style scoped>
.SelectFont {
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.label {
  display: flex;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
  text-align: left;
  color: #648EEA;
  font-size: 16px;
}

.text-label {
  width: 90%;
  padding: 2%;
}

.cont-select {
  max-height: 0px;
  border-radius: 5px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.contselect {
  border-radius: 5px;
  /* padding: 3%;
  margin-top: 1%; */
  max-height: 200px;
  transition: max-height 0.4s ease-in;
}

.cont-s {
  padding: 3.3%;
}

.cont-r {
  padding: 3.3%;
  padding-top: 0;
}
</style>